<template>
  <header class="p-relative d-flex" :class="headerClasses">
    <nav class="d-flex jc-between" :class="navClasses">
      <div class="d-flex">
        <div class="logo d-flex ai-center">
          <router-link
            active-class="active"
            tag="a"
            class="d-flex ai-end"
            :to="`/${this.$i18n.locale}/`"
          >
            <img src="/assets/logo_IOT.svg" alt="logo" />
          </router-link>
        </div>
        <div v-if="!hideNav && !hideAll" class="d-flex ai-center mt-1 nav-menu">
          <router-link
            active-class="active"
            v-if="isLogin"
            tag="a"
            :to="`/${this.$i18n.locale}/design`"
          >
            {{ $t("nav.design") }}
          </router-link>
          <a v-else @click="openSignInDialog('design')">
            {{ $t("nav.design") }}
          </a>
          <router-link
            active-class="active"
            tag="a"
            :to="`/${this.$i18n.locale}/faq`"
          >
            {{ $t("nav.faq") }}
          </router-link>
          <a @click="toggleShow">{{ $t("nav.contact") }}</a>
        </div>
      </div>
      <div class="d-flex" v-if="!hideAll">
        <div class="d-flex ai-center">
          <v-btn icon x-large dark class="mr-6" @click="openVideo">
            <img
              src="/assets/ic/header/ic_header_instruction_white.svg"
              alt="instruction icon"
            />
          </v-btn>
          <Notification></Notification>
          <v-menu auto offset-y nudge-bottom="10" light>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" x-large dark class="mr-6">
                <img
                  src="/assets/ic/header/ic_header_language_white.svg"
                  alt="notification icon"
                />
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, idx) in languages"
                :key="item + idx"
                @click="handleLang(item.lang)"
              >
                <v-list-item-title>{{ item.display }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <Cart v-if="!hideNav"></Cart>
          <v-menu auto offset-y nudge-top="-10" light>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" width="3rem" height="3rem" dark>
                <div v-if="hasAvatar" class="avatar">
                  <img :src="avatar" alt="" />
                </div>
                <img
                  v-else
                  class="nav-icon icon-avatar"
                  :src="avatar"
                  alt="user icon"
                />
              </v-btn>
            </template>
            <v-list v-if="!isLogin">
              <v-list-item @click="openSignInDialog">
                <v-list-item-title> {{ $t("nav.login") }} </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list v-else>
              <v-list-item :to="`/${this.$i18n.locale}/profile`">
                <v-list-item-title> {{ $t("nav.profile") }} </v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-title> {{ $t("nav.logout") }} </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </nav>
    <v-dialog v-model="videoDialog" width="75%">
      <v-responsive :aspect-ratio="16 / 9">
        <video class="video-player" controls>
          <source src="/assets/rfid_design.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </v-responsive>
    </v-dialog>
  </header>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Notification from "./Notification";
import Cart from "./Cart";
import { disconnectWS } from "@/plugins/websocket";
export default {
  components: { Notification, Cart },
  computed: {
    ...mapState("user", ["isLogin", "hasAvatar", "avatar", "notification"]),
    ...mapState("header", [
      "background",
      "fixedTop",
      "higher",
      "hideNav",
      "hideAll"
    ]),
    headerClasses() {
      return {
        "bg-home": this.background === "home",
        "bg-normal": this.background === "default",
        "is-higher": this.higher
      };
    },
    navClasses() {
      return {
        "fix-top": this.fixedTop
      };
    }
  },
  data() {
    return {
      languages: [
        { display: "正體中文", lang: "zh-TW" },
        { display: "简体中文", lang: "zh-CN" },
        { display: "English", lang: "en" }
      ],
      videoDialog: false
    };
  },
  methods: {
    ...mapMutations("signInDialog", ["setVisible", "setAfterLogin"]),
    ...mapMutations("user", ["clearUser"]),
    ...mapMutations("contact", ["toggleShow", "clearMessage"]),
    ...mapActions("user", ["getAvatar"]),
    handleLang(locale) {
      if (locale !== this.$i18n.locale) {
        const to = this.$router.resolve({ params: { locale } });
        this.$i18n.locale = locale;
        this.$router.push(to.location);
      }
    },
    openVideo() {
      //window.open("/assets/rfid_design.mp4");
      this.videoDialog = true;
    },
    async logout() {
      await this.$http.post("signout");
      this.$cookies.remove("token");
      this.$cookies.remove("notification");
      disconnectWS();
      this.clearUser();
      this.clearMessage();
      this.$router.push(`/${this.$i18n.locale}`);
      //window.location.reload();
    },
    openSignInDialog(design = null) {
      console.log(design);
      this.setVisible(true);
      if (design) this.setAfterLogin(design);
      //this.$store.commit("signInDialog/setVisible", true);
    },
    async clickNotification() {
      if (!this.isLogin) return;
      const res = await this.$http.get("members/notification");
      console.log(res.data);
    }
  },
  created() {
    this.getAvatar();
  }
};
</script>

<style lang="sass" scoped>
.bg-normal
  background-image: linear-gradient(135deg, #262B47 0%, #1F212D 100%)
.bg-home
  z-index: 2
  background: transpraent
  background-image: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(255,255,255,0.00) 87%)
.bg-transparent
  z-index: 2
  background: transpraent
.fix-top
  position: absolute
  z-index: 10
  top: 0
  left: 0
.is-higher
  height: 15rem
  min-height: 15rem
.avatar
  width: 3rem
  height: 3rem
  border-radius: 100%
  border: 2px solid white
  box-shadow: 2px 2px 6px #c7c7c7
  overflow: hidden
  display: flex
  > img
    object-fit: contain
    flex: 1
    height: 100%

nav
  width: 100%
  height: 6.1rem
  padding-left: 1.75rem
  padding-right: 3.5rem
  //padding-bottom: 1.4rem
  .logo
    margin-right: 7rem
    img
      //width: 19.4rem
  .nav-menu
    //margin-top: 3.2rem
    > *
      margin-right: 2.05rem
      color: white
      transition: color ease-in-out 0.1s
      &:hover
        color: rgba(255, 255 ,255, 0.8)

  .nav-icon
    width: 2.5rem
    &.icon-avatar
      width: 3rem
      height: 3rem

.video-player
  width: 100%
  height: 100%
</style>
